(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/about/about.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/about/about.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"div-header\" id=\"about\" >\n  <div class=\"container\">\n    <h4 class=\"text-center\">ABOUT</h4>\n  </div>\n</div>\n<div class=\"about-banner\">\n  <div class=\"container\">\n    <div class=\"row about\">\n      <div class=\"col- col-md-4\">\n        <div class=\"side-logo\">\n          <img src=\"/../assets/images/logo/logo.png\"class=\"img-100\">\n        </div>\n      </div>\n      <div class=\"col-md-8 col-\">\n        <p>\n          Glyph is one of the largest mobile services and content providers in the Philippines. The company\n          has developed unique mobile services for all three major carriers in the country: Smart Communications,\n          Globe Telecom and Sun Cellular.\n          <br><br>\n          Today, Glyph has developed different software and platforms such as website, SMS Campaigns (using our unified\n          access code 5677), chatbots, prepaid loading and distribution network and prepaid card/loyalty platforms.\n        </p>\n      </div>\n    </div>\n    <!-- <div class=\"row\">\n      <div class=\"col-md-12 col-\">\n        <div class=\"persons\">\n          <h5 class=\"text-center\">Our Team</h5>\n          <p class=\"text-center\">\n            <b>President and CEO</b>\n            <br>\n            Gerry Amisola\n          </p>\n        </div>\n      </div>\n      <div class=\"col-md-12 col-\">\n        <div class=\"row about-person\">\n          <div class=\"col-md-3 col-\">\n            <p>\n              <b>Senior Developer</b>\n              <br>\n              Jason Embuscado\n            </p>\n          </div>\n          <div class=\"col-md-3 col-\">\n            <p>\n              <b>Project Manager</b>\n              <br>\n              Mark Marifosque\n            </p>\n          </div>\n          <div class=\"col-md-3 col-\">\n            <p>\n              <b>Project Manager</b>\n              <br>\n              Al Dela Pena\n            </p>\n          </div>\n          <div class=\"col-md-3 col-\">\n            <p>\n              <b>Project Manager</b>\n              <br>\n              Tyrone Rabago\n            </p>\n          </div>\n        </div>\n      </div>\n    </div> -->\n  </div>\n  <div class=\"container-fluid\">\n    <div class=\"partners-logo\">\n      <div class=\"row\">\n        <div class=\"col-md-12 col-\">\n          <div class=\"our-partners\">\n            <h5 class=\"text-center\">Our Partners</h5>\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img\">\n            <img src=\"/../assets/images/partners/bayadcenter.png\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img\">\n            <img src=\"/../assets/images/partners/jollibee.png\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img\">\n            <img src=\"/../assets/images/partners/chowking.png\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img lazada\">\n            <img src=\"/../assets/images/partners/lazada2.jpg\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img\">\n              <img src=\"/../assets/images/partners/greenwich.png\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-4\">\n          <div class=\"partner-img\">\n            <img src=\"/../assets/images/partners/redribbon.png\"class=\"img-100\">\n          </div>\n        </div>\n        <div class=\"col-md-1 col-12\">\n          <div class=\"partner-img ebiz\">\n            <img src=\"/../assets/images/partners/ebiz.png\"class=\"img-100\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n<router-outlet></router-outlet>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/cloudlink/cloudlink.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/cloudlink/cloudlink.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-header-block></app-header-block>\n<div class=\"service-page\">\n  <div class=\"div-header\" id=\"services\">\n    <div class=\"container\">\n      <h4 class=\"text-center\">SERVICES</h4>\n    </div>\n  </div>\n  <div class=\"services-banner service-scroll\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <div class=\"col-md-4 col-\">\n          <div class=\"fixed-right\" id=\"fixed-right\">\n            <a  [routerLink]=\"['/services']\">\n              <div class=\"bg-service bg-service-cloud\">\n                <img src=\"/../assets/images/cloud.png\" alt=\"\">\n              </div>\n            </a>\n            <br>\n            <ul>\n              <li>\n                <button  class=\"service-btn\" [ngx-scroll-to]=\"'#adv'\">\n                  <i class=\"fas fa-caret-right\"></i>&nbsp;Cloud Link Advantages\n                </button>\n              </li>\n              <li>\n                <button  class=\"service-btn\" [ngx-scroll-to]=\"'#flow'\">\n                  <i class=\"fas fa-caret-right\"></i>&nbsp;Cloud Link Flow\n                </button>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"col-md-8 col-\">\n          <div class=\"phoenix-container\">\n            <div class=\"phoenix-service adv\" id=\"adv\" #adv>\n              <h1>Cloud Link Advantages</h1>\n              <div class=\"row clAdv\">\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Cloudlink/advantages/1.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Data is extracted by reading receipts. No need no integrate with Merchant POS.</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Cloudlink/advantages/2.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">No App needed. Works with Facebook Messenger and SMS.</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Cloudlink/advantages/3.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Open to all brands and merchants.</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Cloudlink/advantages/4.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Can send targeted rewards and marketing messages based on purchase history and consumer profile.</p>\n                </div>\n              </div>\n            </div>\n            <div class=\"phoenix-service flow\" id=\"flow\" #flow>\n              <h1>Cloud Link Flow</h1>\n              <h4 class=\"text-center\">Link CRM</h4>\n              <div class=\"row link\">\n                <div class=\"col-3\" (click)=\"showCust()\">\n                  <p class=\"text-center\">Customer Link <i class=\"fas fa-caret-right\"></i></p>\n                  <img src=\"../../assets/images/Cloudlink/flow/1.png\" alt=\"\">\n                </div>\n                <div class=\"col-1\">\n                  <div class=\"center-element\">\n                    <i class=\"fas fa-arrow-right\"></i>\n                  </div>\n                </div>\n                <div class=\"col-3\" (click)=\"showData()\">\n                  <p class=\"text-center\">Data Link <i class=\"fas fa-caret-right\"></i></p>\n                  <img src=\"../../assets/images/Cloudlink/flow/2.png\" alt=\"\">\n                </div>\n                <div class=\"col-1\">\n                  <div class=\"center-element\">\n                    <i class=\"fas fa-arrow-right\"></i>\n                  </div>\n                </div>\n                <div class=\"col-3\" (click)=\"showRewards()\">\n                  <p class=\"text-center\">Rewards Link <i class=\"fas fa-caret-right\"></i></p>\n                  <img src=\"../../assets/images/Cloudlink/flow/3.png\" alt=\"\">\n                </div>\n                <div class=\"col-md-12\">\n                  <img src=\"../../assets/images/Arrow.png\" style=\"width: 72%;\">\n                  <p class=\"text-center\">Personalized Ads and Content</p>\n                </div>\n              </div>\n              <div class=\"row flow-def\">\n                <div class=\"col-12\" [hidden]=\"!def\">\n                  <h4 class=\"text-center\">Definition</h4>\n                </div>\n                <div class=\"col-12\" [hidden]=\"!cust\">\n                  <p class=\"text-center\">Customer Link</p>\n                  <img src=\"../../assets/images/Cloudlink/flow/1.1.png\" alt=\"\">\n                </div>\n                <div class=\"col-12\" [hidden]=\"!data\">\n                  <p class=\"text-center\">Data Link</p>\n                  <img src=\"../../assets/images/Cloudlink/flow/2.1.png\" alt=\"\">\n                </div>\n                <div class=\"col-12\" [hidden]=\"!rewards\">\n                  <p class=\"text-center\">Rewards Link</p>\n                  <img src=\"../../assets/images/Cloudlink/flow/3.1.png\" alt=\"\">\n                </div>\n              </div>\n              <div class=\"row definition\">\n                <div class=\"col-12\" [hidden]=\"!cust\">\n                  <h5 class=\"text-center\">Customer Data Acquisition System</h5>\n                  <br>\n                  <h5>DB &nbsp;<i class=\"fas fa-circle\"></i> POS &nbsp;<i class=\"fas fa-circle\"></i> SMS&nbsp; <i class=\"fas fa-circle\"></i> OCR</h5>\n                </div>\n                <div class=\"col-12\" [hidden]=\"!data\">\n                  <h5 class=\"text-center\">Customer Data Analysis System</h5>\n                  <br>\n                  <h5>Name &nbsp;<i class=\"fas fa-circle\"></i> Age &nbsp;<i class=\"fas fa-circle\"></i> Location &nbsp;<i class=\"fas fa-circle\"></i> Etc</h5>\n                </div>\n                <div class=\"col-12\" [hidden]=\"!rewards\">\n                  <h5 class=\"text-center\">Customer Rewards and Profitting System</h5>\n                  <br>\n                  <h5>Loyalty Programs &nbsp;<i class=\"fas fa-circle\"></i> Rewards System &nbsp;<i class=\"fas fa-circle\"></i> Referral Bonuses</h5>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/contact/contact.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/contact/contact.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"div-header\" id=\"contact\">\n  <div class=\"container\">\n    <h4 class=\"text-center\">CONTACT</h4>\n  </div>\n</div>\n<div class=\"contact-banner\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-7 col-\">\n        <p class=\"contact-text\">\n          Please e-mail us your questions regarding our services.\n          <br><br>\n          Glyph has no intention to use or sell your information to any Third Party that will prejudice your privacy and security.\n          <br><br>\n          The Company is following the DPA Law and all the other policies in the country that requires privacy information.\n        </p>\n\n      </div>\n      <div class=\"col-md-5 col-\">\n        <form  #form=\"ngForm\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n         <div class=\"form-group\">\n           <input type=\"text\" class=\"form-control\" name=\"name\"  placeholder=\"Name\" ngModel required #name=\"ngModel\">\n         </div>\n         <div class=\"form-group\">\n           <input type=\"email\" class=\"form-control\" name=\"email\"  placeholder=\"Email\"  ngModel required #email=\"ngModel\" >\n         </div>\n         <div class=\"form-group\">\n           <input type=\"text\" class=\"form-control\" name=\"mob\"  placeholder=\"Mobile Number\" ngModel required #mob=\"ngModel\">\n         </div>\n         <div class=\"form-group\">\n           <textarea name=\"name\" rows=\"8\" cols=\"30\" name=\"msg\" class=\"form-control\"  placeholder=\"Message\" ngModel required #msg=\"ngModel\"></textarea>\n         </div>\n         <button  class=\"btn btn-primary\">Send</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col\">\n        <p>GlyphStudios Inc., Ortigas Center, Pasig City, Philippines</p>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/header-block/header-block.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/header-block/header-block.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-expand-md fixed-top animated fadeInDown relative\" id=\"navbar\">\n  <a class=\"navbar-brand\" href=\"#\">\n    <img src=\"/../assets/images/logo/gwl-w.png\" alt=\"\">\n  </a>\n  <button class=\"navbar-toggler custom-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarText\" aria-controls=\"navbarText\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n    <span class=\"navbar-toggler-icon \"></span>\n  </button>\n  <div class=\"collapse navbar-collapse\" id=\"navbarText\">\n    <ul class=\"navbar-nav ml-auto\">\n      <li class=\"nav-item\">\n        <a class=\"nav-link w3-bar-item w3-button\" [routerLink]=\"['/']\">Home <span class=\"sr-only\">(current)</span></a>\n      </li>\n      <li class=\"nav-item\">\n        <!-- <a class=\"nav-link w3-bar-item w3-button\" [routerLink]=\"['/']\"  [fragment]=\"'about'\">About</a>  -->\n        <a class=\"nav-link w3-bar-item w3-button\" [routerLink]=\"['/about']\">About</a>\n      </li>\n      <li class=\"nav-item\">\n        <a class=\"nav-link w3-bar-item w3-button active\" [routerLink]=\"['/services']\">Services</a>\n      </li>\n      <li class=\"nav-item\">\n        <a class=\"nav-link w3-bar-item w3-button\" [routerLink]=\"['/contact']\">Contact</a>\n      </li>\n    </ul>\n  </div>\n</nav>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<nav class=\"navbar navbar-expand-md fixed-top animated fadeInDown\" id=\"navbar\">\n  <a class=\"navbar-brand\" href=\"#\">\n    <img src=\"/../assets/images/logo/gwl-w.png\" alt=\"\">\n  </a>\n  <button class=\"navbar-toggler custom-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarText\" aria-controls=\"navbarText\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n    <span class=\"navbar-toggler-icon \"></span>\n  </button>\n  <div class=\"collapse navbar-collapse\" id=\"navbarText\">\n    <ul class=\"navbar-nav ml-auto\">\n      <li class=\"nav-item\">\n        <button class=\"nav-link w3-bar-item w3-button\" [ngx-scroll-to]=\"'#home'\">Home <span class=\"sr-only\">(current)</span></button>\n      </li>\n      <li class=\"nav-item\">\n        <button class=\"nav-link w3-bar-item w3-button\"  [ngx-scroll-to]=\"'#about'\" [ngx-scroll-to-offset]=\"ngxScrollToOffset\">About</button>\n      </li>\n      <li class=\"nav-item\">\n        <button class=\"nav-link w3-bar-item w3-button\" [ngx-scroll-to]=\"'#services'\" [ngx-scroll-to-offset]=\"ngxScrollToOffset\">Services</button>\n      </li>\n      <li class=\"nav-item\">\n        <button class=\"nav-link w3-bar-item w3-button\" [ngx-scroll-to]=\"'#contact'\" [ngx-scroll-to-offset]=\"ngxScrollToOffset\">Contact</button>\n      </li>\n    </ul>\n  </div>\n</nav>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html":
/*!********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-header></app-header>\n<div class=\"\"#allServices>\n  <div class=\"\"#allAbout>\n    <div class=\"banner\" id=\"home\" #home>\n      <div class=\"container\">\n        <h1>Creating Innovative Solutions for Consumers</h1>\n      </div>\n    </div>\n    <app-about></app-about>\n  </div>\n  <app-services></app-services>\n</div>\n<app-contact></app-contact>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/phoenix/phoenix.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/phoenix/phoenix.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-header-block></app-header-block>\n<div class=\"service-page\">\n  <div class=\"div-header\">\n    <div class=\"container\">\n      <h4 class=\"text-center\">SERVICES</h4>\n    </div>\n  </div>\n  <div class=\"services-banner service-scroll\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n          <div class=\"col-md-4 col-\">\n            <div class=\"fixed-right\" id=\"fixed-right\">\n              <a  [routerLink]=\"['/services']\">\n                <div class=\"bg-service bg-service-phoenix\">\n                  <img src=\"/../assets/images/phoenix.png\" alt=\"\">\n                </div>\n              </a>\n              <br>\n              <ul>\n                <li> \n                  <button  class=\"service-btn\" [ngx-scroll-to]=\"'#what'\">\n                    <i class=\"fas fa-caret-right\"></i>&nbsp;What can Phoenix do?\n                  </button>\n                </li>\n                <li>\n                  <button class=\"service-btn\" [ngx-scroll-to]=\"'#who'\" [ngx-scroll-to-offset]=\"ngxScrollToOffset\">\n                    <i class=\"fas fa-caret-right\"></i>&nbsp;What is Phoenix for?\n                  </button>\n                </li>\n              </ul>\n            </div>\n        </div>\n        <div class=\"col-md-8 col-\">\n          <div class=\"phoenix-container\">\n            <div class=\"phoenix-service what\" id=\"what\" #what>\n              <h1>What can Phoenix do?</h1>\n              <div class=\"row\">\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Phoenix/1/1.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Create a network of Distributors and Retailers in minutes.</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Phoenix/1/2.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Manage e-wallets and monitor sales up to the Retailer Level.</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Phoenix/1/3.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Support cash transactions using a PCI-DSS Certified Gateway</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/Phoenix/1/4.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">No Smartphone? No problem. Phoenix can work using SMS.</p>\n                </div>\n              </div>\n            </div>\n            <div class=\"phoenix-service who\" id=\"who\" #who>\n              <h1>Who is Phoenix for?</h1>\n              <div class=\"row\">\n                <div class=\"col-\">\n                  <p>\n                    Any Networking Groups, Alumni Associations, Communities, NGOs, Companies,\n                    Sari-sari stores who wants a loading business.\n                  </p>\n                </div>\n                <div class=\"col-12\">\n                  <img src=\"../../assets/images/Phoenix/2/1.png\">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"div-header\" id=\"services\">\n  <div class=\"container\">\n    <h4 class=\"text-center\">SERVICES</h4>\n  </div>\n</div>\n<div class=\"services-banner \">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col- col-md-4\">\n        <div class=\"bg-service bg-service-phoenix\">\n          <img src=\"/../assets/images/phoenix.png\" alt=\"\">\n          <br>\n        </div>\n        <p class=\"desc\">\n          Phoenix is a highly secure, web-based load management platform.\n          It lets you create, load and monitor a community of distributor, retailers and consumer in minutes.\n        </p>\n        <a class=\"bottom\" routerLink=\"/phoenix\">\n          Know more <i class=\"fas fa-caret-right\"></i>\n        </a>\n      </div>\n      <div class=\"col- col-md-4\">\n        <div class=\"bg-service bg-service-sms\">\n          <img src=\"/../assets/images/sms.png\" alt=\"\">\n          <br>\n        </div>\n        <p class=\"desc\">\n          Create and customize SMS campaigns and promos for your business through the use of our unified access number, 5677.\n          This SMS Platform is open to Globe, TM, Smart, TNT, and Sun Cellular Subscribers.\n        </p>\n        <a class=\"bottom\" routerLink=\"/sms\">\n          Know more <i class=\"fas fa-caret-right\"></i>\n        </a>\n      </div>\n      <div class=\"col- col-md-4\">\n        <div class=\"bg-service bg-service-cloud\">\n          <img src=\"/../assets/images/cloud.png\" alt=\"\">\n          <br>\n        </div>\n        <p class=\"desc\">\n          Cloud Link enables brands and companies to create unique loyalty programs by extracting data from consumer receipts.\n        </p>\n        <a class=\"bottom\" routerLink=\"/cloudlink\">\n          Know more <i class=\"fas fa-caret-right\"></i>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/sms/sms.component.html":
/*!******************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/sms/sms.component.html ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-header-block></app-header-block>\n<div class=\"service-page\">\n  <div class=\"div-header\" id=\"services\">\n    <div class=\"container\">\n      <h4 class=\"text-center\">SERVICES</h4>\n    </div>\n  </div>\n  <div class=\"services-banner service-scroll\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n          <div class=\"col-md-4 col-\">\n            <div class=\"fixed-right\" id=\"fixed-right\">\n              <a  [routerLink]=\"['/services']\">\n                <div class=\"bg-service bg-service-sms\">\n                  <img src=\"/../assets/images/sms.png\" alt=\"\">\n                </div>\n              </a>\n              <br>\n              <ul>\n                <li>\n                  <!-- <a  class=\"nav-links active\" data-toggle=\"tab\"  (click)=\"showWhat()\"> -->\n                  <button  class=\"service-btn\" [ngx-scroll-to]=\"'#adv'\">\n                    <i class=\"fas fa-caret-right\"></i>&nbsp;Advantages\n                  </button>\n                </li>\n                <!-- <li>\n                  <a class=\"nav-links\" data-toggle=\"tab\" (click)=\"showPartner()\">\n                    <i class=\"fas fa-caret-right\"></i>&nbsp;Partners\n                  </a>\n                </li> -->\n              </ul>\n            </div>\n        </div>\n        <div class=\"col-md-8 col-\">\n          <div class=\"phoenix-container\">\n            <!-- <div class=\"phoenix-service what\" [ngClass]=\"what ? 'show' : 'none'\"> -->\n            <div class=\"phoenix-service what\" id=\"adv\" #adv>\n              <h1>Advantages</h1>\n              <div class=\"row\">\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/1st.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Authorized Access Code by Telcos</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/2.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Send and Receive messages from the customers</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/3.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Texting can be free to the customers</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/4.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Create and Register to Promo</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/5.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Send Instant Rewards</p>\n                </div>\n                <div class=\"col-md-6 col-12\">\n                  <img src=\"../../assets/images/SMS/Advantages/6.png\" alt=\"\">\n                  <br>\n                  <p class=\"text-center\">Validate Promo Codes</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/about/about.component.scss":
/*!********************************************!*\
  !*** ./src/app/about/about.component.scss ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Fib3V0L2Fib3V0LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/about/about.component.ts":
/*!******************************************!*\
  !*** ./src/app/about/about.component.ts ***!
  \******************************************/
/*! exports provided: AboutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AboutComponent", function() { return AboutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AboutComponent = class AboutComponent {
    constructor() { }
    ngOnInit() {
    }
};
AboutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-about',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./about.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/about/about.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./about.component.scss */ "./src/app/about/about.component.scss")).default]
    })
], AboutComponent);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _phoenix_phoenix_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./phoenix/phoenix.component */ "./src/app/phoenix/phoenix.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var _home_home2_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./home/home2.component */ "./src/app/home/home2.component.ts");
/* harmony import */ var _home_home3_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./home/home3.component */ "./src/app/home/home3.component.ts");
/* harmony import */ var _home_home4_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./home/home4.component */ "./src/app/home/home4.component.ts");
/* harmony import */ var _sms_sms_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./sms/sms.component */ "./src/app/sms/sms.component.ts");
/* harmony import */ var _cloudlink_cloudlink_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./cloudlink/cloudlink.component */ "./src/app/cloudlink/cloudlink.component.ts");










const routes = [
    { path: '', redirectTo: '/', pathMatch: 'full' },
    { path: '', component: _home_home_component__WEBPACK_IMPORTED_MODULE_4__["HomeComponent"] },
    { path: 'phoenix', component: _phoenix_phoenix_component__WEBPACK_IMPORTED_MODULE_3__["PhoenixComponent"] },
    { path: 'sms', component: _sms_sms_component__WEBPACK_IMPORTED_MODULE_8__["SmsComponent"] },
    { path: 'cloudlink', component: _cloudlink_cloudlink_component__WEBPACK_IMPORTED_MODULE_9__["CloudlinkComponent"] },
    { path: 'about', component: _home_home2_component__WEBPACK_IMPORTED_MODULE_5__["HomeComponent2"] },
    { path: 'services', component: _home_home3_component__WEBPACK_IMPORTED_MODULE_6__["HomeComponent3"] },
    { path: 'contact', component: _home_home4_component__WEBPACK_IMPORTED_MODULE_7__["HomeComponent4"] },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");




let AppComponent = class AppComponent {
    constructor(document) {
        this.title = 'glyphweb';
    }
    onWindowScroll(e) {
        if (window.pageYOffset > 550) {
            let element = document.getElementById('navbar');
            element.classList.add('sticky');
        }
        else {
            let element = document.getElementById('navbar');
            element.classList.remove('sticky');
        }
    }
};
AppComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DOCUMENT"],] }] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', ['$event'])
], AppComponent.prototype, "onWindowScroll", null);
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["trigger"])('fade', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["state"])('void', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 0 })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])(':enter', [Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])(300)]),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])(':leave', [Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])(500)]),
            ])
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_3__["DOCUMENT"]))
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _nicky_lenaers_ngx_scroll_to__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @nicky-lenaers/ngx-scroll-to */ "./node_modules/@nicky-lenaers/ngx-scroll-to/fesm2015/nicky-lenaers-ngx-scroll-to.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _header_header_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./header/header.component */ "./src/app/header/header.component.ts");
/* harmony import */ var _about_about_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./about/about.component */ "./src/app/about/about.component.ts");
/* harmony import */ var _services_services_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./services/services.component */ "./src/app/services/services.component.ts");
/* harmony import */ var _contact_contact_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./contact/contact.component */ "./src/app/contact/contact.component.ts");
/* harmony import */ var _phoenix_phoenix_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./phoenix/phoenix.component */ "./src/app/phoenix/phoenix.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./home/home.component */ "./src/app/home/home.component.ts");
/* harmony import */ var _home_home2_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./home/home2.component */ "./src/app/home/home2.component.ts");
/* harmony import */ var _home_home3_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./home/home3.component */ "./src/app/home/home3.component.ts");
/* harmony import */ var _home_home4_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./home/home4.component */ "./src/app/home/home4.component.ts");
/* harmony import */ var _sms_sms_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./sms/sms.component */ "./src/app/sms/sms.component.ts");
/* harmony import */ var _cloudlink_cloudlink_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./cloudlink/cloudlink.component */ "./src/app/cloudlink/cloudlink.component.ts");
/* harmony import */ var _header_block_header_block_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./header-block/header-block.component */ "./src/app/header-block/header-block.component.ts");





















const routes = [
    {
        path: 'item', component: _home_home_component__WEBPACK_IMPORTED_MODULE_14__["HomeComponent"]
    }
];
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"],
            _header_header_component__WEBPACK_IMPORTED_MODULE_9__["HeaderComponent"],
            _about_about_component__WEBPACK_IMPORTED_MODULE_10__["AboutComponent"],
            _services_services_component__WEBPACK_IMPORTED_MODULE_11__["ServicesComponent"],
            _contact_contact_component__WEBPACK_IMPORTED_MODULE_12__["ContactComponent"],
            _phoenix_phoenix_component__WEBPACK_IMPORTED_MODULE_13__["PhoenixComponent"],
            _home_home_component__WEBPACK_IMPORTED_MODULE_14__["HomeComponent"],
            _home_home2_component__WEBPACK_IMPORTED_MODULE_15__["HomeComponent2"],
            _home_home3_component__WEBPACK_IMPORTED_MODULE_16__["HomeComponent3"],
            _home_home4_component__WEBPACK_IMPORTED_MODULE_17__["HomeComponent4"],
            _sms_sms_component__WEBPACK_IMPORTED_MODULE_18__["SmsComponent"],
            _cloudlink_cloudlink_component__WEBPACK_IMPORTED_MODULE_19__["CloudlinkComponent"],
            _header_block_header_block_component__WEBPACK_IMPORTED_MODULE_20__["HeaderBlockComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormsModule"],
            _nicky_lenaers_ngx_scroll_to__WEBPACK_IMPORTED_MODULE_5__["ScrollToModule"].forRoot(),
            _angular_router__WEBPACK_IMPORTED_MODULE_3__["RouterModule"].forRoot(routes)
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/cloudlink/cloudlink.component.scss":
/*!****************************************************!*\
  !*** ./src/app/cloudlink/cloudlink.component.scss ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2Nsb3VkbGluay9jbG91ZGxpbmsuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/cloudlink/cloudlink.component.ts":
/*!**************************************************!*\
  !*** ./src/app/cloudlink/cloudlink.component.ts ***!
  \**************************************************/
/*! exports provided: CloudlinkComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CloudlinkComponent", function() { return CloudlinkComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");



let CloudlinkComponent = class CloudlinkComponent {
    constructor(document) {
        this.cust = false;
        this.data = false;
        this.rewards = false;
        this.def = false;
    }
    showCust() {
        this.def = true;
        this.cust = true;
        this.data = false;
        this.rewards = false;
    }
    showData() {
        this.def = true;
        this.cust = false;
        this.data = true;
        this.rewards = false;
    }
    showRewards() {
        this.def = true;
        this.cust = false;
        this.data = false;
        this.rewards = true;
    }
    ngOnInit() {
        window.scrollTo(0, 0);
    }
    onWindowScroll(e) {
        if (window.pageYOffset > 30) {
            let element2 = document.getElementById('fixed-right');
            element2.classList.add('top-0');
        }
        else {
            let element2 = document.getElementById('fixed-right');
            element2.classList.remove('top-0');
        }
    }
};
CloudlinkComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', ['$event'])
], CloudlinkComponent.prototype, "onWindowScroll", null);
CloudlinkComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-cloudlink',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./cloudlink.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/cloudlink/cloudlink.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./cloudlink.component.scss */ "./src/app/cloudlink/cloudlink.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]))
], CloudlinkComponent);



/***/ }),

/***/ "./src/app/contact/contact.component.scss":
/*!************************************************!*\
  !*** ./src/app/contact/contact.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbnRhY3QvY29udGFjdC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/contact/contact.component.ts":
/*!**********************************************!*\
  !*** ./src/app/contact/contact.component.ts ***!
  \**********************************************/
/*! exports provided: ContactComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactComponent", function() { return ContactComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _server_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../server.js */ "./src/server.js");
/* harmony import */ var _server_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_server_js__WEBPACK_IMPORTED_MODULE_3__);




let ContactComponent = class ContactComponent {
    constructor(http) {
        this.http = http;
    }
    ;
    ngOnInit() {
    }
    onSubmit(form) {
        Object(_server_js__WEBPACK_IMPORTED_MODULE_3__["sendEmail"])(form.form.value);
    }
};
ContactComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
ContactComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-contact',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./contact.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/contact/contact.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./contact.component.scss */ "./src/app/contact/contact.component.scss")).default]
    })
], ContactComponent);



/***/ }),

/***/ "./src/app/header-block/header-block.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/header-block/header-block.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hlYWRlci1ibG9jay9oZWFkZXItYmxvY2suY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/header-block/header-block.component.ts":
/*!********************************************************!*\
  !*** ./src/app/header-block/header-block.component.ts ***!
  \********************************************************/
/*! exports provided: HeaderBlockComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderBlockComponent", function() { return HeaderBlockComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let HeaderBlockComponent = class HeaderBlockComponent {
    constructor(router) {
    }
    ngOnInit() {
    }
};
HeaderBlockComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
HeaderBlockComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header-block',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header-block.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/header-block/header-block.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header-block.component.scss */ "./src/app/header-block/header-block.component.scss")).default]
    })
], HeaderBlockComponent);



/***/ }),

/***/ "./src/app/header/header.component.scss":
/*!**********************************************!*\
  !*** ./src/app/header/header.component.scss ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hlYWRlci9oZWFkZXIuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/header/header.component.ts":
/*!********************************************!*\
  !*** ./src/app/header/header.component.ts ***!
  \********************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HeaderComponent = class HeaderComponent {
    constructor() {
        this.ngxScrollToOffset = -70;
    }
    ngOnInit() {
    }
};
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/header/header.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.component.scss */ "./src/app/header/header.component.scss")).default]
    })
], HeaderComponent);



/***/ }),

/***/ "./src/app/home/home.component.scss":
/*!******************************************!*\
  !*** ./src/app/home/home.component.scss ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2hvbWUvaG9tZS5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/home/home.component.ts":
/*!****************************************!*\
  !*** ./src/app/home/home.component.ts ***!
  \****************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HomeComponent = class HomeComponent {
    constructor() {
        this.ngxScrollToOffset = 300;
    }
    ngOnInit() {
        window.scrollTo(0, 0);
    }
};
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/home/home.component.scss")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/home/home2.component.ts":
/*!*****************************************!*\
  !*** ./src/app/home/home2.component.ts ***!
  \*****************************************/
/*! exports provided: HomeComponent2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent2", function() { return HomeComponent2; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let HomeComponent2 = class HomeComponent2 {
    constructor(router) {
        this.router = router;
        this.ngxScrollToOffset = 300;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.viewHeight = this.elementView.nativeElement.offsetHeight;
        window.scrollTo(0, this.viewHeight - 74);
    }
};
HomeComponent2.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('home', { static: false })
], HomeComponent2.prototype, "elementView", void 0);
HomeComponent2 = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home2',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/home/home.component.scss")).default]
    })
], HomeComponent2);



/***/ }),

/***/ "./src/app/home/home3.component.ts":
/*!*****************************************!*\
  !*** ./src/app/home/home3.component.ts ***!
  \*****************************************/
/*! exports provided: HomeComponent3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent3", function() { return HomeComponent3; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HomeComponent3 = class HomeComponent3 {
    constructor() {
        this.ngxScrollToOffset = 300;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.viewHeight = this.elementView.nativeElement.offsetHeight;
        window.scrollTo(0, this.viewHeight - 74);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('allAbout', { static: false })
], HomeComponent3.prototype, "elementView", void 0);
HomeComponent3 = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home3',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/home/home.component.scss")).default]
    })
], HomeComponent3);



/***/ }),

/***/ "./src/app/home/home4.component.ts":
/*!*****************************************!*\
  !*** ./src/app/home/home4.component.ts ***!
  \*****************************************/
/*! exports provided: HomeComponent4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent4", function() { return HomeComponent4; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HomeComponent4 = class HomeComponent4 {
    constructor() {
        this.ngxScrollToOffset = 300;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.viewHeight = this.elementView.nativeElement.offsetHeight;
        window.scrollTo(0, this.viewHeight - 74);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('allServices', { static: false })
], HomeComponent4.prototype, "elementView", void 0);
HomeComponent4 = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home4',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/home/home.component.scss")).default]
    })
], HomeComponent4);



/***/ }),

/***/ "./src/app/phoenix/phoenix.component.scss":
/*!************************************************!*\
  !*** ./src/app/phoenix/phoenix.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Bob2VuaXgvcGhvZW5peC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/phoenix/phoenix.component.ts":
/*!**********************************************!*\
  !*** ./src/app/phoenix/phoenix.component.ts ***!
  \**********************************************/
/*! exports provided: PhoenixComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhoenixComponent", function() { return PhoenixComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");



let PhoenixComponent = class PhoenixComponent {
    constructor(document) {
        this.ngxScrollToOffset = 40;
    }
    ngOnInit() {
        window.scrollTo(0, 0);
    }
    onWindowScroll(e) {
        if (window.pageYOffset > 30) {
            let element2 = document.getElementById('fixed-right');
            element2.classList.add('top-0');
        }
        else {
            let element2 = document.getElementById('fixed-right');
            element2.classList.remove('top-0');
        }
    }
};
PhoenixComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', ['$event'])
], PhoenixComponent.prototype, "onWindowScroll", null);
PhoenixComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-phoenix',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./phoenix.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/phoenix/phoenix.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./phoenix.component.scss */ "./src/app/phoenix/phoenix.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]))
], PhoenixComponent);



/***/ }),

/***/ "./src/app/services/services.component.scss":
/*!**************************************************!*\
  !*** ./src/app/services/services.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NlcnZpY2VzL3NlcnZpY2VzLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/services/services.component.ts":
/*!************************************************!*\
  !*** ./src/app/services/services.component.ts ***!
  \************************************************/
/*! exports provided: ServicesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServicesComponent", function() { return ServicesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ServicesComponent = class ServicesComponent {
    constructor() { }
    ngOnInit() {
    }
};
ServicesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-services',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./services.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/services/services.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./services.component.scss */ "./src/app/services/services.component.scss")).default]
    })
], ServicesComponent);



/***/ }),

/***/ "./src/app/sms/sms.component.scss":
/*!****************************************!*\
  !*** ./src/app/sms/sms.component.scss ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Ntcy9zbXMuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/sms/sms.component.ts":
/*!**************************************!*\
  !*** ./src/app/sms/sms.component.ts ***!
  \**************************************/
/*! exports provided: SmsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SmsComponent", function() { return SmsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");



let SmsComponent = class SmsComponent {
    constructor(document) {
        this.adv = true;
        this.partner = false;
        this.isService = true;
    }
    showAdv() {
        this.adv = true;
        this.partner = false;
    }
    showPartner() {
        this.adv = false;
        this.partner = true;
    }
    ngOnInit() {
        window.scrollTo(0, 0);
    }
    onWindowScroll(e) {
        if (window.pageYOffset > 30) {
            let element2 = document.getElementById('fixed-right');
            element2.classList.add('top-0');
        }
        else {
            let element2 = document.getElementById('fixed-right');
            element2.classList.remove('top-0');
        }
    }
};
SmsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"],] }] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', ['$event'])
], SmsComponent.prototype, "onWindowScroll", null);
SmsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-sms',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./sms.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/sms/sms.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./sms.component.scss */ "./src/app/sms/sms.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_common__WEBPACK_IMPORTED_MODULE_2__["DOCUMENT"]))
], SmsComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ "./src/server.js":
/*!***********************!*\
  !*** ./src/server.js ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {


module.exports.sendEmail = (form) =>{
  Email.send({
      Host : "smtp.gmail.com",
      Username : "siteadmin@glyphgames.com",
      Password : "glyphweb2019",
      To : ['tyrone@glyphgames.com',"customersupport@glyphgames.com"],
      From : "siteadmin@glyphgames.com",
      Subject : "Contact Us",
      Body : `<b>Name:</b> ${form.name} <br> <b>Email</b>: ${form.email}<br> <b>Mobile</b>: ${form.mob}<br> <b>Message</b>:<br> ${form.msg}`
  }).then(
    message => alert('Succesfully sent!')
  ).catch(e=>{
    alert('Something went wrong!')
  })
}


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /var/www/html/glyphweb/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map